import { connect } from 'react-redux';

import { disableQuestion, reportQuestion } from '../actions/helpPopupsActions';
import { setQuestion, updateCounters } from '../actions/studyMainActions';
import HelpPopups from '../components/Common/HelpButton/HelpPopUp.jsx';
import {
  getQuestionsDataSelector,
  isStudyingMySubmittedQuestionsSelector,
  isStudyingSubmittedQuestionsSelector,
} from '../components/Study/studyMainSelectors';
import { getUser } from '../components/User/userSelectors';

const mapStateToProps = (state, ownProps) => ({
  questionsData: getQuestionsDataSelector(state),
  user: getUser(state),
  isStudyingSubmittedQuestions: isStudyingSubmittedQuestionsSelector(state),
  isStudyingMySubmittedQuestions: isStudyingMySubmittedQuestionsSelector(state),
});
const mapDispatchToProps = (dispatch) => ({
  disableQuestion: (questionId, chapterId) => {
    dispatch(disableQuestion(questionId, chapterId));
  },
  reportQuestion: (questionId, payload) => {
    dispatch(reportQuestion(questionId, payload));
  },
  setQuestion: (question, questionsData) => {
    dispatch(setQuestion(question, questionsData));
  },
  updateCounters: (answer = null, counterType) => {
    dispatch(updateCounters(answer, counterType));
  },
});

const HelpPopupsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HelpPopups);

export default HelpPopupsContainer;
